import { useContext, type FC } from 'react';
import type { FootprintVolatilityCurvesProps } from './types';
import FootprintVolatilityCurvesContent from './footprint-volatility-curves-content';
import { Widget } from '../../widget';
import TokenSelector from '../../token-selector';
import { FootprintVolatilityCurvesContext } from '../../../../providers/widgets';
import WidgetButtons from '../../widget-buttons';
import { CurrencyTypeEnum, VolSurfaceToken } from '../../../../model/currency_type.enum';

const FootprintVolatilityCurvesWidget: FC<FootprintVolatilityCurvesProps> = (props) => {
  const { widget, actions } = props;

  const {
    currency: token,
    setCurrency: setToken,
    hasDefaultToken,
  } = useContext(FootprintVolatilityCurvesContext);
  const handleSetToken = (value: VolSurfaceToken) => setToken(value as CurrencyTypeEnum);

  return (
    <Widget cardKey={widget.key}>
      <Widget.Header>
        <Widget.Title title={widget.title} />
        <Widget.HeaderPanel>
          <TokenSelector token={token} setToken={handleSetToken} isFixedToken={hasDefaultToken} />
        </Widget.HeaderPanel>
        <Widget.Buttons>
          <WidgetButtons widget={widget} actions={actions} permissions={props.permissions} />
        </Widget.Buttons>
      </Widget.Header>
      <Widget.Content>
        <FootprintVolatilityCurvesContent />
      </Widget.Content>
      <Widget.Footer />
    </Widget>
  );
};

export default FootprintVolatilityCurvesWidget;
